module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hello"
    }
  }, [_c('br'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Graphs list")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('sparklines', {
    attrs: {
      "name": "sparklines"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('linecharts', {
    attrs: {
      "name": "linecharts"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('barcharts')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('horizontal-barcharts')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Sparklines")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Line chart")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Vertical bar chart")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Horizontal bar chart")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49915dc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 41
// module chunks = 0